import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';

const QuestionInlineForm = ({ question, questionSetId, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    text: '',
    help_text: '',
    multi_select: false,
    is_active: true,
    band_set: questionSetId,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (question) {
      setFormData(question);
    }
  }, [question]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.text.trim()) newErrors.text = 'Question text is required';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length === 0) {
      onSave(formData);
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          Question Text <span className="text-red-500">*</span>
        </label>
        <textarea
          name="text"
          placeholder="e.g., Can your child walk independently?"
          value={formData.text}
          onChange={handleChange}
          rows="2"
          className={`w-full px-3 py-2 border ${errors.text ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none text-sm`}
        />
        {errors.text && <p className="text-red-500 text-xs mt-1">{errors.text}</p>}
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          Help Text
        </label>
        <textarea
          name="help_text"
          placeholder="Additional guidance..."
          value={formData.help_text}
          onChange={handleChange}
          rows="2"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none text-sm"
        />
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            name="multi_select"
            checked={formData.multi_select}
            onChange={handleChange}
            className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-2 focus:ring-indigo-500"
            id="multi_select_inline"
          />
          <label htmlFor="multi_select_inline" className="text-sm font-medium text-gray-700 cursor-pointer">
            Multi-select
          </label>
        </div>

        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            name="is_active"
            checked={formData.is_active}
            onChange={handleChange}
            className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-2 focus:ring-indigo-500"
            id="is_active_q_inline"
          />
          <label htmlFor="is_active_q_inline" className="text-sm font-medium text-gray-700 cursor-pointer">
            Active
          </label>
        </div>
      </div>

      <div className="flex justify-end gap-2 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-3 py-1.5 border border-gray-300 rounded-lg text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors flex items-center gap-1"
        >
          <X size={14} /> Cancel
        </button>
        <button
          type="submit"
          className="px-3 py-1.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg text-sm font-semibold hover:shadow-lg transition-shadow flex items-center gap-1"
        >
          <Save size={14} /> {question ? 'Update' : 'Create'}
        </button>
      </div>
    </form>
  );
};

export default QuestionInlineForm;